module.exports = __webpack_public_path__ + "img/scrollForm-hover.7ccf2e6c.png";